import { fileUpload } from "./authService";

// src/api/apiRoutes.js
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const apiRoutes = {
  login: `${BASE_URL}/auth/login`,
  signup: `${BASE_URL}/auth/signup`,
  forgotPassword: `${BASE_URL}/auth/forgot-password`,
  resetPassword: `${BASE_URL}/auth/reset-password`,
  socialLogin: `${BASE_URL}/auth/social-login`,
  verifyLinkedIn: `${BASE_URL}/auth/linkedin/verify`,
  linkedInLogin: `${BASE_URL}/auth/linkedin`,
  softwareList: `${BASE_URL}/home/softwares-list`,
  solutionsList: `${BASE_URL}/home/solutions-list`,
  resources: "/home/resources-list",
  recommendedResources: "/home/recommended-resources-list",
  popularSoftSolList: "/home/popular-soft-solulist",
  categoryAllResourceListing: "/home/category-all-resource-listing",
  resourceDetails: "/home/resources-detail",
  getCategoryBySlug: "/home/get-category-by-slug",
  categoryProductList: "/product/category-product-List",
  popularMentions: "/product/search-tools",
  categoryProductDetail: "/product/category-product-detail",
  marketSegmentsList: "/product/market-segments-list",
  integrationsList: "/product/integrations-list",
  languagesList: "/product/languages-list",
  rolesList: "/product/designations-list",
  industriesList: "/product/industries-list",
  getAllCommunityQuestions: "/community/get-all-community-questions",
  getMyCommunityAnswers: "/community/get-mycommunity-answers",
  submitCommunityAnswer: "/community/submit-community-answer",
  createCommunityQuestion: "/community/create-community",
  updateCommunityAnswer: "/community/update-community-answer",
  removeCommunityAnswer: "/community/removed-community-answer",
  removeCommunityQuestion: "/community/removed-community-question",
  toggleFavorite: "/activity/toggle-favorite",
  followUser: "/activity/follow-following",
  checkFollowStatus: "/activity/check-following-status",
  getIndustriesList: "/auth/industries-list",
  getCompanySizesList: "/auth/company-sizes-list",
  getRegionsList: "/auth/regions-list",
  getMyProfileDetails: "/auth/get-my-detail",
  updateProfile: "/auth/update-profile",
  changePassword: "/auth/change-password",
  fileUpload: "/auth/file-upload",
  getMyFavorite: "/activity/get-my-favorite",
  getMyProductSupport: "/activity/get-my-product-support",
  getMyProductSupportWithoutLimit:
    "/activity/get-my-product-support-without-limit",
  getProductList: "/product/get-product-list",
  createSupportList: "/activity/create-suport-list",
  updateSupportList: "/activity/update-suport-list",
  deleteSupportList: "/activity/removed-suport-list",
  getNotificationList: "/activity/notifications-list",
  getFollowersList: "/activity/get-followers-list",
  getFollowingList: "/activity/get-following-list",
  removeFollowOrUnfollow: "/activity/remove-follow",
  getOtherProfileDetails: "/auth/other-profile-detail",
  getUserProductList: "/product/user-product-list",
  verifyResetToken: "/auth/verify-reset-token",
  getMyReviewList: "/activity/get-my-review-list",
  createReview: "/reviews/create-review",
  updateReview: "/reviews/update-review",
  verifyReview: "/review-verifications",
  createOtp: "/otp",
  verifyOtp: "/otp/verify",
  reviewList: "/reviews/get-all-reviews",
  deleteReview: "/reviews/delete-review",
  getFilters: "/activity/get-filters",
  toggleHelpful: "/activity/toggle-helpful",
  getPriceRangeLimits: "/activity/get-price-range-limits",
  reviewReply: "/review-reply",
  reviewPopularMentions: "/reviews/popular-mentions",
  addDisputeCommentReview: "/review-reply/dispute",
  reviewById: "/reviews/get-single-review",
  searchHome: "/activity/home-search",
  addProduct: "/product",
  badgeRequest: "/badge-requests",
  //   userProfile: `${BASE_URL}/user/profile`,
  // add more here
};

export default apiRoutes;
